$(document).ready(function(){
  if(window.innerWidth > 1025){
    $('.block__cart-drawer-scrolling-image-wrapper').css('height', $('.block__cart-drawer-scrolling-content-inner').height());
  }

     $('.block__cart-drawer-scrolling-image-slider').each(function(){
        var $this = $(this);
         $this.slick({
            draggable: false,
            infinite: true,
            autoplay: true,
            arrows: false,
            autoplaySpeed: 0,
            speed: 8000,
            pauseOnHover: false,
            cssEase: 'linear',
            vertical: true,
            verticalSwiping: true,
            slidesToShow: 3,
            slidesToScroll: 1
      });
    });
})